var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommandSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 36,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 5h-28a2 2 0 0 0 -2 2v22a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-22a2 2 0 0 0 -2-2zm-25.2 10.81v-2.64l10 4.59v2.08l-10 4.59v-2.65l6.51-3zm16.6 9.59h-6.4v-2.4h6.4zm-19.4-16.2v-2.2h28v2.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h36v36h-36z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandSolid);
export default __webpack_public_path__ + "static/media/command-solid.b877a610636a415e9f1d92f45c0180df.svg";
export { ForwardRef as ReactComponent };